module.exports = __webpack_public_path__ + "static/img/logo7.05a4c685.png";